import React, { forwardRef } from 'react';

import { IMaskInput } from 'react-imask';

const MaskedInput = forwardRef((props, ref) => {
  const { onChange, mask, definitions, ...other } = props;

  const handleOnChange = (value) => {
    onChange({ target: { name: props.name, value } });
  };
  return (
    <IMaskInput
      {...other}
      mask={mask}
      data-testid='masked-input'
      definitions={definitions}
      inputRef={ref}
      onAccept={handleOnChange}
      overwrite
    />
  );
});

export default MaskedInput;
